<template>
  <q-header class="header">
    <q-toolbar class="header__toolbar">
      <div v-if="!drawerOpen" class="header__brand">
        <q-btn
          dense
          flat
          icon="menu"
          class="header__burger"
          aria-label="Открыть меню"
          title="Открыть меню"
          @click.prevent="$emit('toggle-navbar')"
        />
        <router-link to="/" class="header__logo">
          <img
            v-if="this.system === 'sbs'"
            style="height: 22px;"
            src="@/assets/img/logo_sbs_blue.svg"
            alt="logo_picture"
          />
          <img v-else src="@/assets/img/logo.svg" alt="logo_picture" />
        </router-link>
      </div>
      <q-space />
      <div class="header__right">
        <!--
        <q-btn
          flat
          round
          dense
          class="it-support-header-btn"
          @click="openItSupport"
        >
          <q-icon name="support_agent" size="22px" color="grey-7" />
          <q-badge
            v-if="itSupportCount > 0"
            color="negative"
            floating
            rounded
            :label="itSupportCount > 9 ? '9+' : String(itSupportCount)"
          />
          <q-tooltip anchor="bottom middle" self="top middle">Служба поддержки</q-tooltip>
        </q-btn>
        -->
        <span class="header__date" :title="todayFull">
          <i class="fa-regular fa-calendar" aria-hidden="true" />{{ today }}
          <span class="header__time">{{ time }}</span>
        </span>
        <NotificationBell />
        <CityBlock header />
        <CompaniesBlock header />
        <span class="header__divider" />
        <div class="user-trigger">
          <span class="user-trigger__avatar">
            <img v-if="userData?.image_url" :src="userData.image_url" alt="" />
            <template v-else>{{ initials }}</template>
          </span>
          <span class="user-trigger__info">
            <span class="user-trigger__name">{{ userData?.fio || 'Пользователь' }}</span>
            <span v-if="userData?.position_name" class="user-trigger__role">{{ userData.position_name }}</span>
          </span>
          <q-icon name="fas fa-chevron-down" class="user-trigger__chevron" />
          <q-menu anchor="bottom right" self="top right" :offset="[0, 6]" class="ms-dropdown">
            <q-list style="min-width: 170px">
              <q-item clickable v-close-popup to="/profile">
                <q-item-section avatar class="user-menu__icon"><q-icon name="fa-regular fa-user" size="14px" /></q-item-section>
                <q-item-section>Профиль</q-item-section>
              </q-item>
              <q-item clickable v-close-popup class="ms-dropdown__danger" @click="handleLogout">
                <q-item-section avatar class="user-menu__icon"><q-icon name="fa-solid fa-arrow-right-from-bracket" size="14px" /></q-item-section>
                <q-item-section>Выйти</q-item-section>
              </q-item>
            </q-list>
          </q-menu>
        </div>
      </div>
    </q-toolbar>
  </q-header>
</template>

<script>
import CityBlock from "@/components/features/cityBlock";
import CompaniesBlock from "@/components/features/companiesBlock";
import NotificationBell from "@/components/notifications/NotificationBell.vue";
import { PAGES } from "@/constants";
import { getSystemCode } from "@/services";
import { appActionTypes } from "@/services/store/modules/app_module/app_mutation_types";

export default {
  name: "Header",
  props: {
    // открыто ли левое меню: при открытом ☰ и логотип в хедере не нужны (они есть в самом меню)
    drawerOpen: Boolean,
  },
  components: {CompaniesBlock, CityBlock, NotificationBell},
  data() {
    return {
      system: getSystemCode(),
      now: new Date(),
      // itSupportCount: 0,
    };
  },
  computed: {
    pages() {
      return PAGES;
    },
    userData() {
      return this.$store.state.app?.userData
    },
    // «понедельник, 26 октября»
    today() {
      const text = this.now.toLocaleDateString('ru-RU', {weekday: 'long', day: 'numeric', month: 'long'})
      return text.charAt(0).toUpperCase() + text.slice(1)
    },
    // «20:41» (now обновляется таймером clockTimer)
    time() {
      return this.now.toLocaleTimeString('ru-RU', {hour: '2-digit', minute: '2-digit'})
    },
    todayFull() {
      return this.now.toLocaleDateString('ru-RU', {weekday: 'long', day: 'numeric', month: 'long', year: 'numeric'})
    },
    initials() {
      const parts = (this.userData?.fio || '').trim().split(/\s+/).filter(Boolean)
      return parts.slice(0, 2).map(p => p[0].toUpperCase()).join('') || '?'
    },
  },
  // mounted() {
  //   window.addEventListener("it-support:count", this._onItSupportCount);
  //   window.dispatchEvent(new Event("it-support:get-count"));
  // },
  // beforeUnmount() {
  //   window.removeEventListener("it-support:count", this._onItSupportCount);
  // },
  mounted() {
    // раз в 5 секунд: минута сменяется без заметной задержки, лишних перерисовок нет
    this.clockTimer = setInterval(() => {
      this.now = new Date()
    }, 5000)
  },
  beforeUnmount() {
    clearInterval(this.clockTimer)
  },
  methods: {
    handleLogout() {
      this.$store.dispatch(appActionTypes.logout)
    },
    // openItSupport() {
    //   window.dispatchEvent(new Event("it-support:open"));
    // },
    // _onItSupportCount(e) {
    //   this.itSupportCount = e.detail?.count ?? 0;
    // },
  }
};
</script>

<style scoped lang="scss">
// Хедер как в app.buildest.kz: 48px, белый, тонкая линия снизу; справа — пилюли города,
// компании и пользователя. Логотип в хедере только когда меню скрыто (телефон/планшет).
.header {
  background: var(--ms-surface);
  color: var(--ms-text);
  border-bottom: 1px solid var(--ms-border);
  box-shadow: var(--ms-shadow-header);

  &__toolbar {
    min-height: var(--ms-header-h);
    height: var(--ms-header-h);
    padding: 0 20px 0 12px;
    gap: 10px;

    @media (max-width: 768px) {
      padding: 0 10px 0 6px;
    }
  }

  &__burger {
    width: 32px;
    height: 32px;
    border-radius: var(--ms-radius-sm);
    color: #475569;

    &:hover {
      color: var(--ms-primary);
    }
  }

  // ☰ и логотип — только когда меню закрыто
  &__brand {
    display: flex;
    align-items: center;
    gap: 8px;
    flex-shrink: 0;
  }

  &__logo {
    display: flex;
    align-items: center;

    img {
      height: 30px;
    }
  }

  &__date {
    display: inline-flex;
    align-items: center;
    gap: 7px;
    padding: 0 6px;
    font-size: 13px;
    font-weight: 500;
    color: var(--ms-text-secondary);
    white-space: nowrap;

    i {
      font-size: 13px;
      color: var(--ms-primary);
    }

    @media (max-width: 991px) {
      display: none;
    }
  }

  &__time {
    padding-left: 8px;
    margin-left: 2px;
    border-left: 1px solid var(--ms-border);
    color: var(--ms-text);
    font-variant-numeric: tabular-nums;
  }

  &__right {
    display: flex;
    align-items: center;
    gap: 10px;
    min-width: 0;

    @media (max-width: 576px) {
      gap: 4px;
    }
  }

  &__divider {
    width: 1px;
    height: 18px;
    background: var(--ms-border);

    @media (max-width: 768px) {
      display: none;
    }
  }
}

.it-support-header-btn {
  display: none;

  @media (max-width: 768px) {
    display: inline-flex;
  }
}

.user-trigger {
  display: flex;
  align-items: center;
  gap: 8px;
  min-width: 0;
  padding: 4px 10px 4px 4px;
  border-radius: 9999px;
  background: var(--ms-primary-50);
  border: 1px solid var(--ms-border);
  cursor: pointer;
  transition: border-color 0.15s, background 0.15s;

  &:hover {
    border-color: var(--ms-primary);
    background: var(--ms-primary-100);
  }

  &__avatar {
    width: 30px;
    height: 30px;
    flex-shrink: 0;
    border-radius: 50%;
    overflow: hidden;
    display: flex;
    align-items: center;
    justify-content: center;
    background: linear-gradient(135deg, var(--ms-primary), var(--ms-primary-ink));
    color: #fff;
    font-size: 12px;
    font-weight: 700;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }

  &__info {
    display: flex;
    flex-direction: column;
    min-width: 0;
    line-height: 1.25;
  }

  &__name {
    max-width: 160px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 12px;
    font-weight: 600;
    color: var(--ms-primary-ink);
  }

  &__role {
    max-width: 160px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    font-size: 10px;
    color: var(--ms-muted);
  }

  &__chevron {
    font-size: 10px;
    color: var(--ms-muted);
  }

  @media (max-width: 768px) {
    padding: 3px;

    &__info,
    &__chevron {
      display: none;
    }
  }
}

.user-menu__icon {
  min-width: 26px !important;
  padding-right: 0;
  font-size: 13px;
}
</style>
